import React, { useEffect } from "react";
import { login } from "./authUtility";

const AzureLogin = () => {
  useEffect(() => {
    login();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: "20px",
      }}
    >
      <img
        alt="Edenred Logo"
        style={{ height: "100px", width: "260px" }}
        src={require("assets/img/icons/common/C3Pay_Logo.png")}
      />
      <h1 style={{ fontSize: "24px", fontWeight: "bold" }}>Welcome !</h1>
      <p>Logging you in...</p>
    </div>
  );
};

export default AzureLogin;
